import React from 'react';
import Sidebar from '../learnSidebar';
import NavbarLearn from '../navbarLearn';
import useDocumentTitle from '../useDocumentTitle'
import image1 from "../../img/OneC1.jpg"
import image2 from "../../img/OneC2.jpg"
import image3 from "../../img/OneC3.JPG"

export default function OneC() {
    useDocumentTitle("Chapter 1 Lesson C | 101Learn by the Spartabots")
    return (
        <div>
            <NavbarLearn />
            <div class="flex max-w-[100rem] mx-auto my-5 bg-gradient-to-r from-frcyellow to-frcpurple rounded-[2rem] items-center">
                <p class="font-scoutcond font-black italic text-white opacity-50 text-[30rem] ml-10 leading-none">01-C</p>
                <h class="z-20 absolute font-scoutcond font-black italic text-frcblue text-[10rem] ml-40 leading-none">THE FRC SEASON</h>
                <p class="absolute ml-[9.4rem] mt-44 font-scoutcond font-black italic text-white text-[4rem] leading-none">LESSON 1-C</p>
            </div>
            <div class="flex flex-row max-w-[100rem] mx-auto mb-5">
                <div class="hidden md:flex basis-80 bg-gray-300 rounded-l-[2rem]">
                    <Sidebar />
                </div>
                <div class="basis-full h-full bg-gray-50 rounded-r-[2rem]">
                    <div class="mx-10 my-10">
                        <h class="font-scoutcond font-black italic text-[5rem] leading-none">LESSON OVERVIEW</h>
                        <p class="font-productsans font-bold text-3xl text-gray-400">How does an FRC Season even work?</p>
                        <p class="font-productsans text-base text-black mt-5">This lesson goes over the general structure of an FRC Season - to skip ahead, click on the chapter roadmap below:</p>
                        <a href="/learn/one">
                            <p class="font-avenir font-bold text-base text-frcblue mt-10 leading-none">CHAPTER 1</p>
                            <p class="font-scoutcond font-black text-[3rem] leading-none">FRC BASICS</p>
                        </a>
                        <div class="border-l-2 ml-5">
                            <ul class="font-productsans font-bold ml-3">
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/one/a">What is FRC?</a>
                                    <p class="font-productsans font-normal ml-3">Get to know the actual premise of the FIRST Robotics Competition, how a season works, and other programs that FIRST offers.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/one/b">Prior Experience</a>
                                    <p class="font-productsans font-normal ml-3">Understand what kinds of prior activities and experience would be beneficial to your FRC time. Prior experience is not necessary, but does make the learning process faster!</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-frcpurple duration-300" href="/learn/one/c">What does FRC do?</a>
                                    <p class="font-productsans font-normal ml-3">Introduce yourself to the norms of the FRC Season, what we do, and why you should join.</p>
                                </li>
                            </ul>
                        </div>
                        <h class="block font-scoutcond font-black italic text-[5rem] leading-none mt-20">A TYPICAL FRC YEAR</h>
                        <p class="font-productsans text-lg text-black">A standard year is divided up into categories: preseason, build season, competition season, and off-season. 
                        </p>
                        <p class="font-productsans text-lg mt-5 text-black">In preseason, teams usually educate new members, try out new mechanisms, and prepare for the build season.
                        </p>
                        <img src={image1} class="my-5 rounded-[1rem]" alt="Preseason"></img>

                        <p class="font-productsans text-lg mt-5 text-black">In the build season, each team is given 6 weeks to build their robot. The annual challenge is usually announced at “Kickoff”, an event hosted at the start of January.
                        During the 6 weeks after this day, teams will design, build, and code the robot to prepare for competition with others.
                        </p>
                        <img src={image2} class="my-5 rounded-[1rem]" alt="Build Season"></img>

                        <p class="font-productsans text-lg mt-5 text-black">In the competition season, teams compete at local events to earn points to qualify for district and world events. The culminating FIRST world championship happens in mid-April, and is an event that covers FLL, FTC, and FRC.
                        </p>
                        <img src={image3} class="my-5 rounded-[1rem]" alt="Competition Season"></img>

                    </div>
                </div>
            </div>
        </div>
    )
}